import { render } from "./JoinBetHeader.vue?vue&type=template&id=2b05f144"
import script from "./JoinBetHeader.vue?vue&type=script&lang=js"
export * from "./JoinBetHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__